import { chakra } from '@chakra-ui/react'
import { ImgProxy as BaseImgProxy } from '@yta/image-proxy'

export const ImgProxy = chakra(BaseImgProxy)
